import { render, staticRenderFns } from "./BaseDropdown.vue?vue&type=template&id=df456e8a&scoped=true"
import script from "./BaseDropdown.vue?vue&type=script&lang=js"
export * from "./BaseDropdown.vue?vue&type=script&lang=js"
import style0 from "./BaseDropdown.vue?vue&type=style&index=0&id=df456e8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df456e8a",
  null
  
)

export default component.exports